import { render, staticRenderFns } from "./accountFrom.vue?vue&type=template&id=31fbecfe&scoped=true"
import script from "./accountFrom.vue?vue&type=script&lang=js"
export * from "./accountFrom.vue?vue&type=script&lang=js"
import style0 from "./accountFrom.vue?vue&type=style&index=0&id=31fbecfe&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "31fbecfe",
  null
  
)

export default component.exports